import { render, staticRenderFns } from "./aviso.vue?vue&type=template&id=418fa8cf&lang=html"
import script from "./aviso.vue?vue&type=script&lang=js"
export * from "./aviso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports